// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"36bbca00","453":"04a0eaa6","743":"d9382b6a"}[chunkId] + ".chunk.js";
};